<div class="container" *ngIf="loaded">
  <mat-card>
    <h2 translate>request.historical.title</h2>
    <span>{{ 'request.historical.text' | translate }} {{ dataHistoric.total }}</span>
  </mat-card>
  <mat-card class="historical" *ngFor="let register of dataHistoric.registers; let i = index">
    <div class="date">
      <span class="marginRight order">{{ i + 1 }}</span>
      <span class="marginRight">{{ register.date }} - {{ register.time }}</span>
    </div>
    <div class="commentary">
      <span>{{ register.commentary }}</span>
    </div>
    <div class="user">
      <span>{{ register.user }}</span>
    </div>
  </mat-card>
</div>
